import { useIntl } from '@capsicum/common';
import { GenericDrawer, useGoatImage } from '@capsicum/common-web';
import { type WalletSuccessfulWithdrawStatus } from '@capsicum/features/wallet/shared';

import { WithdrawResume } from '../withdraw-resume/WithdrawResume';

export type ConfirmationModalProps = {
	amount?: string;
	reference?: string;
	status?: WalletSuccessfulWithdrawStatus;
	testID: string;
};

export const ConfirmationModal = ({ amount, reference, status, testID }: ConfirmationModalProps) => {
	const { $t } = useIntl();
	const goatSoldImage = useGoatImage('congratulations');

	const confirmationDrawerData = {
		image: goatSoldImage,
		testID: testID,
		title: $t('wallet.withdraw.processingDrawer.title')
	};

	return (
		<GenericDrawer {...confirmationDrawerData}>
			{status && <WithdrawResume amount={amount} reference={reference} status={status} />}
		</GenericDrawer>
	);
};
